import { lazy } from 'react';

import { config } from '@grafana/runtime';
import { FlagKeys, getFeatureFlagClient } from '@grafana/runtime/internal';
import { type RouteDescriptor } from 'app/core/navigation/types';

export const SAVED_QUERIES_BASE_URL = '/saved-queries';

export function getSavedQueriesRoutes(): RouteDescriptor[] {
  // The dedicated page requires both the query library feature and the page-specific flag.
  if (
    !config.featureToggles.queryLibrary ||
    !getFeatureFlagClient().getBooleanValue(FlagKeys.GrafanaSavedQueriesPage, false)
  ) {
    return [];
  }

  return [
    {
      path: SAVED_QUERIES_BASE_URL,
      component: lazy(
        () => import(/* webpackChunkName: "SavedQueriesPage" */ './SavedQueries/SavedQueriesPage/SavedQueriesPage')
      ),
    },
    {
      path: `${SAVED_QUERIES_BASE_URL}/:uid`,
      component: lazy(
        () =>
          import(/* webpackChunkName: "SavedQueryDetailPage" */ './SavedQueries/SavedQueriesPage/SavedQueryDetailPage')
      ),
    },
  ];
}
